import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarPais } from "../../services/pais.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
} from "../../components/molecules/ShowAlert";

export const PaisCard = ({ pais = {}, index, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarPais(pais.idPais);
            showDeletedAlert({
              callback: () => onDelete?.(pais.idPais),
            });
          } catch (error) {
            console.error("Error al eliminar el país:", error);
            const errorMessage = error.response?.data?.message || "Error al eliminar el país";
            showErrorAlert({ text: errorMessage });
          }
        }
      },
    });
  };

  const handleUpdate = () => {
    navigate(`/pais/actualizar/${pais.idPais}`);
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 text-sm [&>td]:text-gray-700 border-gray-200">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{pais.nombre || "-"}</td>
      <td className="border-slate-200 border-t">
        <div className="flex flex-wrap justify-evenly items-center gap-2">
          <button
            onClick={handleUpdate}
            className="bg-green-500 hover:bg-green-600 p-1 rounded text-white"
            title="Editar"
          >
            <EditIcon className="w-5 h-5" />
          </button>

          <button
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 p-1 rounded text-white"
            title="Eliminar"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};